export default "__VITE_ASSET__DsY4Jk5Z__"